import { useState, useEffect, useRef, useCallback } from "react";

export default function useComponentVisible(initialIsVisible, callback, portalId) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef(null);

  const handleHideDropdown = useCallback(
    (event) => {
      if (event.key === "Escape") {
        setIsComponentVisible(false);
        if (callback && isComponentVisible) {
          callback();
        }
      }
    },
    [callback, isComponentVisible]
  );

  const handleClickOutside = useCallback(
    (event) => {
      const modalConfirm = document.getElementById("modal-confirm");
      const modalGeneric = document.getElementById("modal-generic");
      const portalElement = portalId ? document.getElementById(portalId) : null;

      if (
        ref.current &&
        !ref.current.contains(event.target) &&
        !(modalConfirm && modalConfirm.contains(event.target)) &&
        !(modalGeneric && modalGeneric.contains(event.target)) &&
        !(portalElement && portalElement.contains(event.target))
      ) {
        setIsComponentVisible(false);
        if (callback && isComponentVisible) {
          callback();
        }
      }
    },
    [callback, isComponentVisible, portalId]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [handleClickOutside, handleHideDropdown]);

  return { ref, isComponentVisible, setIsComponentVisible, handleClickOutside, handleHideDropdown };
}
